import React from 'react'

import MessageTitle from './MessageTitle'

/**
 * Return the correct display name for each message
 * @param {object} props
 * @param {object} props.user
 * @param {string} props.user.name
 * @param {[{origin: string, provider: string}]} props.user.channels
 * @param {string} props.user.provider_id
 * @param {string} props.type message type
 * @param {string} [props.typeTitle] Title for some messages, optional
 * @param {string} [operatorName]
 */
const DisplayNameMsg = (props) => {
  const { user, type, typeTitle = '', operatorName = '', fromName = '', customClassName } = props

  return (
    <p
      className={`
        username
        new-size-font
        text-ellipsis
        ${customClassName ? customClassName : ''}
      `}
    >
      <MessageTitle
        type={type}
        user={user}
        typeTitle={typeTitle}
        operatorName={operatorName}
        fromName={fromName}
      />
    </p>
  )
}

export default DisplayNameMsg
